import { LogbogIndlaeg } from './LogbogIndlaeg'; 
export class OpretLogbogIndlaeg {
        public holdId: string;
        public logbogAfsnitId: string;
        public opgavepakkeOpgaveId: string;
        public logbogIndlaeg: LogbogIndlaeg;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/OpretLogbogIndlaeg.ts